import { __decorate, __param } from 'tslib';
import { Optional, Self, Inject, NgZone, ElementRef, Renderer2, Input, Directive, NgModule } from '@angular/core';
import { ANIMATION_FRAME } from '@ng-web-apis/common';
import { POLLING_TIME } from '@taiga-ui/cdk/constants';
import { TUI_FOCUSABLE_ITEM_ACCESSOR, TUI_IS_IOS } from '@taiga-ui/cdk/tokens';
import { setNativeFocused } from '@taiga-ui/cdk/utils/focus';
import { race, timer, Observable } from 'rxjs';
import { throttleTime, map, skipWhile, take } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'rxjs';
const TIMEOUT = 1000;
const NG_ANIMATION_SELECTOR = '.ng-animating';
// TODO: in 3.0 change input name to tuiAutoFocus and handle empty string
// TODO: refactor on this whole thing in 3.0
let TuiAutoFocusDirective = class TuiAutoFocusDirective {
    constructor(tuiFocusableComponent, isIos, animationFrame$, ngZone, elementRef, renderer) {
        this.tuiFocusableComponent = tuiFocusableComponent;
        this.isIos = isIos;
        this.animationFrame$ = animationFrame$;
        this.ngZone = ngZone;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.autoFocus = true;
    }
    ngAfterViewInit() {
        if (!this.autoFocus) {
            return;
        }
        if (this.isTextFieldElement) {
            if (this.isIos) {
                this.ngZone.runOutsideAngular(() => this.iosWebkitAutofocus());
            }
            else {
                race(timer(TIMEOUT), this.animationFrame$.pipe(throttleTime(POLLING_TIME), map(() => this.element.closest(NG_ANIMATION_SELECTOR)), skipWhile(Boolean), take(1))).subscribe(() => setNativeFocused(this.element));
            }
            return;
        }
        setNativeFocused(this.element);
    }
    get element() {
        var _a;
        return (((_a = this.tuiFocusableComponent) === null || _a === void 0 ? void 0 : _a.nativeFocusableElement) ||
            this.elementRef.nativeElement);
    }
    get isTextFieldElement() {
        return this.element.matches('input, textarea');
    }
    iosWebkitAutofocus() {
        var _a;
        const fakeInput = this.renderer.createElement('input');
        fakeInput.style.position = 'absolute';
        fakeInput.style.opacity = '0';
        fakeInput.style.height = '0';
        const blurHandler = () => setNativeFocused(fakeInput);
        const focusHandler = () => {
            setTimeout(() => {
                setNativeFocused(this.element);
                /**
                 * @note:
                 * We can't remove the element immediately, because it breaks flow
                 */
                setTimeout(() => {
                    fakeInput.removeEventListener('blur', blurHandler);
                    fakeInput.removeEventListener('focus', focusHandler);
                    fakeInput.remove();
                });
            });
        };
        /**
         * @note: ping-pong eager strategy hack
         * After creating an element and bringing it into DOM,
         * the browser automatically focuses on the invisible element.
         * And then, after focus is triggered, we try to focus on target element, and if we managed to refocus,
         * then we try to focus again on an invisible element, so that the keyboard slowly appears.
         * This ping pong allows the keyboard to not overlap the modal window.
         */
        fakeInput.addEventListener('blur', blurHandler, { once: true });
        fakeInput.addEventListener('focus', focusHandler);
        (_a = this.element.parentElement) === null || _a === void 0 ? void 0 : _a.appendChild(fakeInput);
        setNativeFocused(fakeInput);
    }
};
TuiAutoFocusDirective.ɵfac = function TuiAutoFocusDirective_Factory(t) { return new (t || TuiAutoFocusDirective)(ɵngcc0.ɵɵdirectiveInject(TUI_FOCUSABLE_ITEM_ACCESSOR, 10), ɵngcc0.ɵɵdirectiveInject(TUI_IS_IOS), ɵngcc0.ɵɵdirectiveInject(ANIMATION_FRAME), ɵngcc0.ɵɵdirectiveInject(NgZone), ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(Renderer2)); };
TuiAutoFocusDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiAutoFocusDirective, selectors: [["", "tuiAutoFocus", ""]], inputs: { autoFocus: "autoFocus" } });
TuiAutoFocusDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Self }, { type: Inject, args: [TUI_FOCUSABLE_ITEM_ACCESSOR,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_IS_IOS,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [ANIMATION_FRAME,] }] },
    { type: NgZone, decorators: [{ type: Inject, args: [NgZone,] }] },
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: Renderer2, decorators: [{ type: Inject, args: [Renderer2,] }] }
];
__decorate([
    Input()
], TuiAutoFocusDirective.prototype, "autoFocus", void 0);
TuiAutoFocusDirective = __decorate([ __param(0, Optional()),
    __param(0, Self()),
    __param(0, Inject(TUI_FOCUSABLE_ITEM_ACCESSOR)),
    __param(1, Inject(TUI_IS_IOS)),
    __param(2, Inject(ANIMATION_FRAME)),
    __param(3, Inject(NgZone)),
    __param(4, Inject(ElementRef)),
    __param(5, Inject(Renderer2))
], TuiAutoFocusDirective);

let TuiAutoFocusModule = class TuiAutoFocusModule {
};
TuiAutoFocusModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiAutoFocusModule });
TuiAutoFocusModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiAutoFocusModule_Factory(t) { return new (t || TuiAutoFocusModule)(); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiAutoFocusDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiAutoFocus]'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Self
            }, {
                type: Inject,
                args: [TUI_FOCUSABLE_ITEM_ACCESSOR]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_IS_IOS]
            }] }, { type: ɵngcc1.Observable, decorators: [{
                type: Inject,
                args: [ANIMATION_FRAME]
            }] }, { type: ɵngcc0.NgZone, decorators: [{
                type: Inject,
                args: [NgZone]
            }] }, { type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc0.Renderer2, decorators: [{
                type: Inject,
                args: [Renderer2]
            }] }]; }, { autoFocus: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiAutoFocusModule, { declarations: [TuiAutoFocusDirective], exports: [TuiAutoFocusDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiAutoFocusModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiAutoFocusDirective],
                exports: [TuiAutoFocusDirective]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiAutoFocusDirective, TuiAutoFocusModule };

//# sourceMappingURL=taiga-ui-cdk-directives-auto-focus.js.map